var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWandMagicSparkles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_306_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5977 6.88867L12.0801 7.46289C11.957 7.50391 11.875 7.62695 11.875 7.75C11.875 7.91406 11.957 8.03711 12.0801 8.07812L13.5977 8.65234L14.1719 10.1699C14.2129 10.293 14.3359 10.375 14.5 10.375C14.623 10.375 14.7461 10.293 14.7871 10.1699L15.3613 8.65234L16.9199 8.07812C17.043 8.03711 17.125 7.91406 17.125 7.75C17.125 7.62695 17.043 7.50391 16.9199 7.46289L15.3613 6.88867L14.7871 5.33008C14.7461 5.20703 14.623 5.125 14.5 5.125C14.3359 5.125 14.2129 5.20703 14.1719 5.33008L13.5977 6.88867ZM5.88672 21.3672C5.10742 22.1465 5.10742 23.377 5.88672 24.1562L7.28125 25.5508C8.06055 26.3301 9.29102 26.3301 10.0703 25.5508L25.6973 9.92383C26.4766 9.14453 26.4766 7.91406 25.6973 7.13477L24.3027 5.74023C23.5234 4.96094 22.293 4.96094 21.5137 5.74023L5.88672 21.3672ZM23.8516 8.5293L19.5449 12.8359L18.6016 11.8926L22.9082 7.58594L23.8516 8.5293ZM4.28711 9.96484C4.12305 10.0059 4 10.2109 4 10.375C4 10.5801 4.12305 10.7852 4.28711 10.8262L6.625 11.6875L7.48633 14.0254C7.52734 14.1895 7.73242 14.3125 7.9375 14.3125C8.10156 14.3125 8.30664 14.1895 8.34766 14.0254L9.25 11.6875L11.5469 10.8262C11.752 10.7852 11.875 10.5801 11.875 10.375C11.875 10.2109 11.752 10.0059 11.5469 9.96484L9.25 9.0625L8.34766 6.76562C8.30664 6.56055 8.10156 6.4375 7.9375 6.4375C7.73242 6.4375 7.52734 6.56055 7.48633 6.76562L6.625 9.0625L4.28711 9.96484ZM18.7246 20.4648C18.5605 20.5059 18.4375 20.7109 18.4375 20.875C18.4375 21.0801 18.5605 21.2852 18.7246 21.3262L21.0625 22.1875L21.9238 24.5254C21.9648 24.6895 22.1699 24.8125 22.375 24.8125C22.5391 24.8125 22.7441 24.6895 22.7852 24.5254L23.6875 22.1875L25.9844 21.3262C26.1895 21.2852 26.3125 21.0801 26.3125 20.875C26.3125 20.7109 26.1895 20.5059 25.9844 20.4648L23.6875 19.5625L22.7852 17.2656C22.7441 17.0605 22.5391 16.9375 22.375 16.9375C22.1699 16.9375 21.9648 17.0605 21.9238 17.2656L21.0625 19.5625L18.7246 20.4648Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_306_22",
    x: 0,
    y: 0.960938,
    width: 30.4766,
    height: 29.3691,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_306_22"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_306_22",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWandMagicSparkles);
export default __webpack_public_path__ + "static/media/wand-magic-sparkles.9ae2022ef461d437a1e1dba4c1fb90b5.svg";
export { ForwardRef as ReactComponent };